module.exports = __webpack_public_path__ + "img/cargo-wagon-4.7f32f40f.png";